export default "__VITE_ASSET__DPC5N8OZ__"